export const EVENT_FEATURE_FLAGS = {
  account: 'useAuroraAccountEventMigrationPhase',
  funnel: 'useAuroraFunnelEventMigrationPhase',
  home: 'useAuroraHomeEventMigrationPhase',
  movements: 'useAuroraMovementsEventMigrationPhase',
};
